// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sa-answer-spinner-ring {
  box-sizing: border-box;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
  border-radius: 50%;
  border: 2px solid var(--sdk-gloabl-border-color);
  border-top-color: var(--sdk-global-theme-color);
  animation: results-spin 0.7s linear infinite;
}

.sa-answer-results-loading-container {
  min-height: 200px;
}

.sa-answer-no-results-container .sa-answer-no-results-icon {
  width: 36px;
  height: 36px;
}

.sa-answer-search-filters-section .sa-answer-search-input .sa-answer-search-field {
  padding: 8px 12px 8px 36px;
}
.sa-answer-search-filters-section .sa-answer-search-input svg {
  position: absolute;
  left: 11px;
}

.sa-answer-filters-container .sa-answer-filter-badge-wrapper .sa-answer-filter-badge {
  padding: 2px 12px;
}
.sa-answer-filters-container .sa-answer-source-dropdown {
  position: absolute;
  width: 250px;
  box-shadow: 0 12px 16px -4px var(--Focus-Ring-Neutral-8-pg, rgba(16, 24, 40, 0.08)), 0 4px 6px -2px var(--Focus-Ring-Neutral-4-pg, rgba(16, 24, 40, 0.04));
  z-index: 1;
  bottom: auto;
  margin-top: 4px;
}
.sa-answer-filters-container .sa-answer-source-dropdown .sa-answer-dropdown-item .sa-answer-dropdown-item-icon {
  width: 16px;
  height: 16px;
}

.sa-answer-results-container .sa-answer-result-card {
  background: var(--sdk-gloabl-bg-secondary);
}
.sa-answer-results-container .sa-answer-result-card .sa-answer-result-header {
  padding: var(--xs, 8px) var(--default, 8px);
}
.sa-answer-results-container .sa-answer-result-card .sa-answer-result-header .sa-answer-file-info-wrapper .sa-answer-file-icon {
  width: 12px;
  height: 12px;
}
.sa-answer-results-container .sa-answer-result-card .sa-answer-result-header .sa-answer-file-info-wrapper .sa-answer-file-icon svg {
  width: 100%;
  height: 100%;
}
.sa-answer-results-container .sa-answer-result-card .sa-answer-result-header .sa-answer-file-info-wrapper .sa-answer-file-name-wrapper:hover {
  color: var(--sdk-global-theme-color);
}
.sa-answer-results-container .sa-answer-result-content {
  padding: 8px;
}
.sa-answer-results-container .sa-answer-result-content .sa-answer-result-text-section .sa-answer-text-container .kwsdk-line-clamp-3 {
  word-break: break-word;
  overflow-wrap: break-word;
}
.sa-answer-results-container .sa-answer-result-content .sa-answer-result-text-section .sa-answer-text-container .kwsdk-line-clamp-3.sa-answer-expanded {
  display: block !important;
}
.sa-answer-results-container .sa-answer-result-content .sa-answer-has-table + .sa-answer-see-more-link {
  inset-block-end: 37px;
}
.sa-answer-results-container .sa-answer-result-content .sa-answer-has-table.sa-answer-has-no-text + .sa-answer-see-more-link {
  display: none;
}
.sa-answer-results-container .sa-answer-result-content .sa-answer-see-more-link, .sa-answer-results-container .sa-answer-result-content .sa-answer-see-less-link {
  inset-inline-end: 0px;
  inset-block-end: 0px;
  color: var(--sdk-global-theme-color);
  cursor: pointer;
}
.sa-answer-results-container .sa-answer-result-content .sa-answer-related-results .sa-answer-divider {
  border: 1px solid var(--sdk-gloabl-border-color);
}

.sa-answer-image-thumbnail-wrapper {
  width: 64px;
  height: 48px;
  cursor: pointer;
}
.sa-answer-image-thumbnail-wrapper .sa-answer-result-text-image-img {
  object-fit: cover;
}
.sa-answer-image-thumbnail-wrapper .sa-answer-image-zoom-overlay {
  transform: translate(-50%, -50%);
  width: 24px;
  height: 24px;
  background: transparent;
  opacity: 0;
  visibility: hidden;
}
.sa-answer-image-thumbnail-wrapper:hover {
  border: 1px solid var(--sdk-global-theme-color);
}
.sa-answer-image-thumbnail-wrapper:hover::after {
  position: absolute;
  content: "";
  top: 0;
  background-color: rgba(16, 24, 40, 0.5803921569);
  width: 100%;
  height: 100%;
}
.sa-answer-image-thumbnail-wrapper:hover .sa-answer-image-zoom-overlay {
  opacity: 1;
  visibility: visible;
}

@keyframes results-spin {
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/plugins/answers/templates/relevantResultsTemplate/relevantResults.scss"],"names":[],"mappings":"AAEA;EACI,sBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,gDAAA;EACA,+CAAA;EACA,4CAAA;AADJ;;AAGA;EACI,iBAAA;AAAJ;;AAII;EACI,WAAA;EACA,YAAA;AADR;;AAQQ;EACI,0BAAA;AALZ;AAOQ;EACI,kBAAA;EACA,UAAA;AALZ;;AAaQ;EACI,iBAAA;AAVZ;AAaI;EACI,kBAAA;EACA,YAAA;EACA,0JAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;AAXR;AAaY;EACI,WAAA;EACA,YAAA;AAXhB;;AAkBI;EACI,0CAAA;AAfR;AAgBQ;EACI,2CAAA;AAdZ;AAgBgB;EACI,WAAA;EACA,YAAA;AAdpB;AAkBoB;EACI,WAAA;EACA,YAAA;AAhBxB;AAoBoB;EACI,oCAAA;AAlBxB;AAwBI;EACI,YAAA;AAtBR;AAyBgB;EACI,sBAAA;EACA,yBAAA;AAvBpB;AAwBoB;EACI,yBAAA;AAtBxB;AA2BQ;EACI,qBAAA;AAzBZ;AA2BQ;EACI,aAAA;AAzBZ;AA4BQ;EACI,qBAAA;EACA,oBAAA;EACA,oCAAA;EACA,eAAA;AA1BZ;AA6BY;EACI,gDAAA;AA3BhB;;AAgCA;EACI,WAAA;EACA,YAAA;EACA,eAAA;AA7BJ;AA+BI;EACI,iBAAA;AA7BR;AAgCI;EACI,gCAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,UAAA;EACA,kBAAA;AA9BR;AAiCI;EACI,+CAAA;AA/BR;AAgCQ;EACI,kBAAA;EACA,WAAA;EACA,MAAA;EACA,gDAAA;EACA,WAAA;EACA,YAAA;AA9BZ;AAgCQ;EACI,UAAA;EACA,mBAAA;AA9BZ;;AAoCA;EACI;IACI,yBAAA;EAjCN;AACF","sourcesContent":["\n\n.sa-answer-spinner-ring {\n    box-sizing: border-box;\n    width: 24px;\n    height: 24px;\n    flex-shrink: 0;\n    border-radius: 50%;\n    border: 2px solid var(--sdk-gloabl-border-color);\n    border-top-color: var(--sdk-global-theme-color);\n    animation: results-spin 0.7s linear infinite;\n}\n.sa-answer-results-loading-container{\n    min-height: 200px;\n}\n\n.sa-answer-no-results-container{\n    .sa-answer-no-results-icon{\n        width: 36px;\n        height: 36px;\n    }\n}\n\n    \n.sa-answer-search-filters-section{\n    .sa-answer-search-input{\n        .sa-answer-search-field{\n            padding: 8px 12px 8px 36px;\n        }\n        svg{\n            position: absolute;\n            left: 11px;\n        }\n    }\n}\n\n\n.sa-answer-filters-container{\n    .sa-answer-filter-badge-wrapper{\n        .sa-answer-filter-badge{\n            padding: 2px 12px;\n        }\n    }\n    .sa-answer-source-dropdown{\n        position: absolute;\n        width: 250px;\n        box-shadow: 0 12px 16px -4px var(--Focus-Ring-Neutral-8-pg, rgba(16, 24, 40, 0.08)), 0 4px 6px -2px var(--Focus-Ring-Neutral-4-pg, rgba(16, 24, 40, 0.04));\n        z-index: 1;\n        bottom: auto;\n        margin-top: 4px;\n        .sa-answer-dropdown-item{\n            .sa-answer-dropdown-item-icon{\n                width: 16px;\n                height: 16px;\n            }\n        }\n    }\n}\n\n.sa-answer-results-container{\n    .sa-answer-result-card{\n        background: var(--sdk-gloabl-bg-secondary);\n        .sa-answer-result-header{\n            padding: var(--xs, 8px) var(--default, 8px);\n            .sa-answer-file-info-wrapper{\n                .sa-answer-file-icon{\n                    width: 12px;\n                    height: 12px;\n                    &.json{\n\n                    }\n                    svg{\n                        width: 100%;\n                        height: 100%;\n                    }\n                }\n                .sa-answer-file-name-wrapper{\n                    &:hover{\n                        color: var(--sdk-global-theme-color);\n                    }\n                }\n            }\n        }\n    }\n    .sa-answer-result-content{\n        padding: 8px;\n        .sa-answer-result-text-section{\n            .sa-answer-text-container{\n                .kwsdk-line-clamp-3{\n                    word-break: break-word;\n                    overflow-wrap: break-word;\n                    &.sa-answer-expanded{\n                        display: block !important;\n                    }\n                }\n            }\n        }\n        .sa-answer-has-table + .sa-answer-see-more-link {\n            inset-block-end: 37px;\n        }\n        .sa-answer-has-table.sa-answer-has-no-text + .sa-answer-see-more-link {\n            display: none;\n        }\n   \n        .sa-answer-see-more-link , .sa-answer-see-less-link{\n            inset-inline-end: 0px;\n            inset-block-end: 0px;\n            color: var(--sdk-global-theme-color);\n            cursor: pointer;\n        }\n        .sa-answer-related-results{\n            .sa-answer-divider{\n                border: 1px solid var(--sdk-gloabl-border-color);\n            }\n        }\n    }\n}\n.sa-answer-image-thumbnail-wrapper{\n    width: 64px;\n    height: 48px;\n    cursor: pointer;\n\n    .sa-answer-result-text-image-img {\n        object-fit: cover;\n    }\n\n    .sa-answer-image-zoom-overlay {\n        transform: translate(-50%, -50%);\n        width: 24px;\n        height: 24px;\n        background: transparent;\n        opacity: 0;\n        visibility: hidden;\n    }\n\n    &:hover {\n        border: 1px solid var(--sdk-global-theme-color);\n        &::after {\n            position: absolute;\n            content: '';\n            top: 0;\n            background-color: #10182894;\n            width: 100%;\n            height: 100%;\n        }\n        .sa-answer-image-zoom-overlay {\n            opacity: 1;\n            visibility: visible;\n        }\n    }\n}\n\n\n@keyframes results-spin {\n    to {\n        transform: rotate(360deg);\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
